<section *ngIf="loaded; else elseBlock">
  <p>Choose what to do when a group of records are considered duplicates:</p>
  <div class="masterIdentification-entity" *ngFor="let entity of ['candidate', 'clientContact','clientCorporation']">
    <h3>
      <i class="bhi-{{ utilsService.getEntityIcon(entity) }}"></i>
      {{ utilsService.getEntityLabel(entity) }}
    </h3>
    <ul [matTooltip]="showTooltip ? 'Drag up or down to change ordering' : null" matTooltipPosition="left">
      <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event, getStrategySelections(entity), entity)">
        <h4>The "master" record will be selected as the record that has the...</h4>
        <li class="example-box" cdkDrag *ngFor="let col of getStrategySelections(entity)">
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" name="columnDirection" aria-label="Column Direction"
            [(ngModel)]="col.direction" (change)="simpleMasterIdentificationChange(entity)">
            <mat-button-toggle value="ASC">{{getAscDescLabel(col,entity,'ASC')}}</mat-button-toggle>
            <mat-button-toggle value="DESC">{{getAscDescLabel(col,entity,'DESC')}}</mat-button-toggle>
          </mat-button-toggle-group>
          <label matTooltip="{{ getTooltip(col.column, entity) }}">{{ getUserFriendlyLabel(col.column, entity) }}</label>
          <span class="material-icons notranslate drag_handle">drag_handle</span>
        </li>
      </div>
    </ul>
    <ul>
      <li class="example-box" *ngFor="let customMap of getCustomStrategyMapping(entity)">
        <label>{{ customMap.fieldIdentifier }}</label>
        <mat-select class="full-width" placeholder="Select field:" [disabled]="isDisabled" (click)="showDataToolsLiteMessage()"
                      (selectionChange)="customMasterIdentificationHasChanged(entity, customMap)"
                      [(ngModel)]="customMap.bullhornField">
            <mat-option *ngFor="let option of getCustomStrategyMappingFields(entity)"
                        [value]="option.fieldName"
                        [disabled]="isFieldAlreadySelected(option.fieldName, entity, customMap.fieldIdentifier)">
              {{ option.fieldLabel + ' (' + option.fieldName + ')' }}
            </mat-option>
          </mat-select>

        <!-- Comparison type selector (only for TO_MANY fields) -->
        <mat-select *ngIf="isToManyField(customMap, entity)"
                    class="comparison-type-select"
                    placeholder="Compare by:"
                    [disabled]="isDisabled"
                    [value]="getComparisonType(customMap)"
                    (selectionChange)="setComparisonType(entity, customMap, $event.value)">
          <mat-option *ngFor="let option of getOperationTypeOptions()" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>

        <span *ngIf="customMap.bullhornField" [matTooltip]="'Clear'" (click)="clearSelection(entity,customMap)"
              matTooltipPosition="below" class="material-icons notranslate close">close</span>
      </li>
    </ul>
  </div>
</section>
<ng-template #elseBlock>
  <app-loading></app-loading>
</ng-template>
